var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPaymentProcess = function SvgIconPaymentProcess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13902 2.34246e-05C1.40802 2.34246e-05 -0.000976562 1.44202 -0.000976562 3.21402V14.074H1.68202V3.21302C1.68202 2.36802 2.33502 1.68002 3.13902 1.68002H23.345C24.149 1.68002 24.803 2.36802 24.803 3.21302V15.063C24.803 15.909 24.149 16.597 23.345 16.597H16.99V18.277H23.344C25.074 18.277 26.483 16.836 26.483 15.063V3.21302C26.483 1.44102 25.073 -0.000976562 23.343 -0.000976562H3.14002L3.13902 2.34246e-05Z",
    fill: "#B0B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.735 6.37H22.748V4.69H3.735V6.37ZM10.607 15.391L12.008 16.594H0V18.275H12.01L10.607 19.478L11.702 20.753L15.572 17.434L11.702 14.115L10.607 15.391Z",
    fill: "#B0B5C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPaymentProcess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-payment-process.bbeb2b52.svg";
export { ForwardRef as ReactComponent };